import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('nl');

  useEffect(() => {
    // Check URL for /en/ prefix
    const path = window.location.pathname;
    if (path.startsWith('/en')) {
      setLanguage('en');
    } else {
      setLanguage('nl');
    }
  }, []);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const switchLanguage = (lang) => {
    setLanguage(lang);
    const currentPath = window.location.pathname;
    
    if (lang === 'en') {
      if (!currentPath.startsWith('/en')) {
        window.history.pushState({}, '', `/en${currentPath === '/' ? '' : currentPath}`);
      }
    } else {
      if (currentPath.startsWith('/en')) {
        const newPath = currentPath.replace('/en', '') || '/';
        window.history.pushState({}, '', newPath);
      }
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
